import { QUERY_KEYS } from 'api/query-keys';
import { shiftService } from 'ogp/services';
import { GetCalendarShiftPlanningListItemsParams } from 'ogp/services/shift-service.types';
import { useInfiniteQuery } from 'react-query';
import { CACHE_TIME_MEDIUM } from 'shared/react-query/query-defaults';

export const useGetCalendarShiftsPlanning = (
  params: Omit<GetCalendarShiftPlanningListItemsParams, 'page'>
) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.shiftPlanning(params),
    queryFn: async ({ pageParam = 0 }) =>
      await shiftService.getCalendarShiftPlanningListItems({ ...params, page: pageParam }),
    cacheTime: CACHE_TIME_MEDIUM,
    staleTime: CACHE_TIME_MEDIUM,
    keepPreviousData: true,
    getNextPageParam: (_, allGroups) => {
      const filteredAllGroups = allGroups.filter((g) => g.planning.departments.length > 0);
      const pageAlreadyFetched = allGroups[filteredAllGroups.length];
      if (pageAlreadyFetched) {
        return undefined;
      }
      return filteredAllGroups.length;
    },
  });
};
